import React from 'react'
import MultiStateToggle from '../../helpers/toggle'

class BenefitOverrideModal extends React.Component {
  constructor (props) {
    super (props)
    const benefit = this.props.detail.benefit
    this.state = {
      show: this.props.detail.show,
      id: benefit.id,
      eligible: benefit.eligibility,
      eligible_leave_hours: benefit.eligible_hours,
      actual_leave_start_date: benefit.start_date,
      actual_leave_end_date: benefit.end_date,
      reason: benefit.reason || '',
      current_month: moment(benefit.start_date, 'MM/DD/YYYY').format('YYYY-MM-DD'),
      intermittent: benefit.intermittent,
      intermittent_dates: this.buildContinuousIntermittentDates(benefit.intermittent_dates),
      intermittent_access: this.props.intermittent_access,
      using_benefit: benefit.using_benefit,
      leave_start_milestone_date: benefit.leave_start_milestone_date,
      leave_end_milestone_date: benefit.leave_end_milestone_date,
      max_end_date: benefit.max_end_date,
      pending: benefit.pending,
      eligible_intermittent_dates: benefit.eligible_intermittent_dates
    }
    const {
      leave_start_milestone_date,
      leave_end_milestone_date
    } = this.state
    this.eligibleDates = this.enumerateDaysBetweenDates(leave_start_milestone_date, leave_end_milestone_date)
    this.handleIntermittentDateChange = this.handleIntermittentDateChange.bind(this)
  }

  componentDidMount () {
    this.initializeBootstrapSwitchEligible()
    this.initializeBootstrapSwitchIntermittent()
    this.initializeBootstrapSwitchUsing()
    this.initializeDatePicker()
    if (this.state.intermittent) {
      this.initializeCalendars()
    }
    this.titleWeek()
  }

  componentDidUpdate () {
    this.initializeDatePicker()
    if (this.state.intermittent) {
      this.initializeCalendars()
    }
    this.initializeBootstrapSwitchIntermittent()
    this.initializeBootstrapSwitchUsing()
    this.titleWeek()
  }

  initializeCalendars () {
    for (var calendar=0; calendar <= 2; calendar++) {
      this.initializeDatePickerFor(calendar)
      this.bindWeek(calendar)
    }
  }

  titleWeek () {
    let weeks = $('th.cw')
    weeks.each((i) => {
      weeks[i].innerText = "Wk"
    })
  }

  buildContinuousIntermittentDates (intermittent_dates) {
    let continuous_ranges = []
    let last_date_range = ''
    intermittent_dates.map(range => {
      return {
        start_date: moment(range.start_date).toDate(),
        end_date: moment(range.end_date).toDate()
      }
    }).sort((a, b) => {
      return a.start_date.less_than(b.start_date) ?
        -1 : 1
    }).forEach((range) => {
      last_date_range = continuous_ranges[continuous_ranges.length - 1]
      if (last_date_range && this.exclusivelyOverlaps(last_date_range, range)) {
        last_date_range.end_date = range.end_date
      } else {
        continuous_ranges.push(range)
      }
    })
    return continuous_ranges
  }

  dateConstraints (datepicker) {
    if ($(datepicker).hasClass('actual-start-datepicker')) {
      return {
        startDate: this.state.leave_start_milestone_date,
        endDate: this.state.leave_end_milestone_date
      }
    } else if ($(datepicker).hasClass('intermittent')){
      return {}
    }
    else {
      return {
        startDate: this.state.actual_leave_start_date,
        endDate: this.state.max_end_date
      }
    }
  }

  initializeDatePicker () {
    const _this = this
    $('.datepicker')
      .unbind('changeDate')
      .datepicker('destroy')
    $.each($('.datepicker'), (index, datepicker) => {
      let options = {...{format: 'mm/dd/yyyy', clearBtn: true}, ..._this.dateConstraints(datepicker)}
      $(datepicker).datepicker(
        options
      ).on('changeDate', (e) => {
        let temp = {}
        let name = $(e.target).data('name')
        let value = e.target.value
        if (name.includes('-')){
          let ind = name.split('-')[1]
          let nameTag = name.split('-')[0]
          let ranges = _this.state.eligible_intermittent_dates
          ranges[ind][nameTag] = value
          _this.setState({eligible_intermittent_dates: ranges})
        } else{
          temp[name] = value
          _this.setState(temp)
        }
        $(e.target).datepicker('hide')
        if (name === 'actual_leave_start_date') {
          _this.calculateLeaveEndDate(value, _this.state.eligible_leave_hours)
        }
      }).keydown(false)
    })
  }

  disabledDatesFor(calendar)  {
    const approxStartOfCalendar = this.defaultDateFor(calendar).startOf('month').add(-1, 'months')
    const approxEndOfCalendar = this.defaultDateFor(calendar).endOf('month').add(1, 'months')
    const approxDatesOfCalendar = this.enumerateDaysBetweenDates(approxStartOfCalendar, approxEndOfCalendar)
    return approxDatesOfCalendar.filter(date => this.eligibleDates.indexOf(date) < 0)
  }

  initializeDatePickerFor (calendar) {
    $(`.intermittent-calendar-${calendar}`)
      .unbind('changeDate')
      .datepicker('destroy')
    let defaultViewDate = this.defaultDateFor(calendar).format('YYYY-MM-DD')
    let startDate = moment.max(this.defaultDateFor(calendar).startOf('month'), moment(this.state.leave_start_milestone_date, 'MM/DD/YYYY')).format('YYYY-MM-DD')
    let endDate = moment.min(this.defaultDateFor(calendar).endOf('month'), moment(this.state.leave_end_milestone_date)).format('YYYY-MM-DD')
    $(`.intermittent-calendar-${calendar}`).datepicker({
      format: 'yyyy-mm-dd',
      multidate: true,
      calendarWeeks: true,
      defaultViewDate: defaultViewDate,
      datesDisabled: this.disabledDatesFor(calendar)
    })
    $('.datepicker-switch').removeClass('datepicker-switch')
    this.setDatesFor(calendar)
    $(`.intermittent-calendar-${calendar}`).on('changeDate', (e) => {
      this.handleIntermittentDaySelection(e, calendar)
    })
  }

  handleIntermittentDaySelection (e, calendar) {
    const previousDates = gon[`calendar_${calendar}_dates`]
    const selected = previousDates.length < e.dates.length
    let selectedDate
    if (selected) {
      selectedDate = e.date
    } else {
      const deletedDates = previousDates.filter(previousDate => {
        return e.dates.map(date => {
          return moment(date).format('YYYY-MM-DD')
        }).indexOf(previousDate) < 0
      })
      selectedDate = moment(deletedDates[0]).toDate()
    }
    this.handleIntermittentDateChange({start_date: selectedDate, end_date: selectedDate})
  }

  defaultDateFor (calendar) {
    return moment.utc(this.state.current_month).add(calendar, 'months')
  }

  setDatesFor (calendar) {
    const dates = this.extractSelectedDatesFor(calendar)
    if (dates.length > 0) {
        $(`.intermittent-calendar-${calendar}`).datepicker('setDates', dates)
      }
  }

  validDateRange (startDate, endDate) {
    let selectedDates = this.enumerateDaysBetweenDates(startDate, endDate)
    let filterSelectedDates = selectedDates.filter( (d) => {
      return (moment(d).toDate().greater_or_equals(moment(this.state.leave_start_milestone_date).toDate()) && moment(d).toDate().less_or_equals(moment(this.state.leave_end_milestone_date).toDate()))
    })
    return {
      start_date: moment(filterSelectedDates[0]).toDate(),
      end_date: moment(filterSelectedDates[filterSelectedDates.length - 1]).toDate()
    }
  }

  toggleLabels() {
   return (
    [
      {
        text: 'Eligible',
        value: 'eligible',
        checked: !this.state.pending && this.state.eligible,
        helperText: 'Employee is eligible to use the benefit in this LeavePlan and will see it in their LeavePlan',
      },
      {
        text: 'Pending',
        value: 'pending',
        checked: this.state.pending,
        helperText: 'Employee may be eligible and will see the benefit in their LeavePlan as Pending HR',
      },
      {
        text: 'Not Eligible',
        value: 'ineligible',
        checked: !this.state.eligible && !this.state.pending,
        helperText: 'Employee is not eligible to use the benefit in this LeavePlan and will not see it in their LeavePlan',
      }
    ]
   )
  }

  bindWeek (calendar) {
    $(`.intermittent-calendar-${calendar} td.cw`).on('click', (e) => {
      let year, wn
      const defaultDate = this.defaultDateFor(calendar)
      const weekNumber = parseInt(e.target.innerText)
      if (defaultDate.month() === 0 && weekNumber > 50) {
        year = String(defaultDate.year() - 1)
      } else if (defaultDate.month() === 11 && weekNumber < 5) {
        year = String(defaultDate.year() + 1)
      } else {
        year = String(defaultDate.year())
      }

      const date = year + "-01-01"

      if (moment.utc(date).isoWeek() === 53) {
        wn =  weekNumber + 1
      } else {
        wn = weekNumber
      }

      const startOfWeek = moment(moment.utc(date).week(wn).startOf('week').format('YYYY-MM-DD')).toDate()
      const endOfWeek = moment(moment.utc(date).week(wn).endOf('week').format('YYYY-MM-DD')).toDate()

      if (startOfWeek.greater_than(moment(this.state.leave_end_milestone_date).toDate()) || endOfWeek.less_than(moment(this.state.leave_start_milestone_date).toDate())) {
        return null
      }

      const selectedRange = this.validDateRange(startOfWeek, endOfWeek)
      this.handleIntermittentDateChange(selectedRange, calendar, 'week')
    })
  }

  isSelected (dateRange) {
    const rangePresent = this.state.intermittent_dates.map((intermittentRange) => {
      const startDate = intermittentRange.start_date
      const endDate = intermittentRange.end_date
      return dateRange.start_date.between(startDate, endDate) && dateRange.end_date.between(startDate, endDate)
    }).indexOf(true) >= 0
    return !rangePresent
  }

  exclusivelyOverlaps (range1, range2) {
    const startDate1 = moment(range1.start_date)
    const endDate1 = moment(range1.end_date)
    const startDate2 = moment(range2.start_date)
    const endDate2 = moment(range2.end_date)
    return startDate1.diff(endDate2) * startDate2.subtract(1, 'days').diff(endDate1) >= 0
  }

  findOverlappedRanges (selectedRange) {
    let {intermittent_dates} = this.state
    let overlappedRanges = []
    let overlappedIndexes = []
    intermittent_dates.forEach((range, index) => {
      if (this.exclusivelyOverlaps(range, selectedRange)) {
        overlappedRanges.push(range)
        overlappedIndexes.push(index)
      }
    })
    return {overlappedRanges: overlappedRanges, overlappedIndexes: overlappedIndexes}
  }

  pushInIntermittent (selectedRange) {
    let {intermittent_dates} = this.state
    const overlappedRangesDetails = this.findOverlappedRanges(selectedRange)
    let overlappedRanges = overlappedRangesDetails.overlappedRanges
    const overlappedIndexes = overlappedRangesDetails.overlappedIndexes
    overlappedRanges.push(selectedRange)
    const newStartDate = moment.min(
      overlappedRanges.map(range => {
        return moment(range.start_date)
      })
    ).toDate()
    const newEndDate = moment.max(
      overlappedRanges.map(range => {
        return moment(range.end_date)
      })
    ).toDate()
    overlappedIndexes.length && intermittent_dates.splice(overlappedIndexes[0], overlappedIndexes.length)
    intermittent_dates.push({start_date: newStartDate, end_date: newEndDate})
    this.setState({
      intermittent_dates: this.buildContinuousIntermittentDates(intermittent_dates)
    })
  }

  popFromIntermittentRange (selectedRange) {
    let {intermittent_dates} = this.state
    const overlappedRangesDetails = this.findOverlappedRanges(selectedRange)
    const overlappedRange = overlappedRangesDetails.overlappedRanges[0]
    const overlappedIndex = overlappedRangesDetails.overlappedIndexes[0]
    intermittent_dates.splice(overlappedIndex, 1)
    if (!overlappedRange.start_date.equals(selectedRange.start_date)) {
      intermittent_dates.push(
        {
          start_date: overlappedRange.start_date,
          end_date: moment(selectedRange.start_date).subtract(1, 'days').toDate()
        }
      )
    }
    if (!overlappedRange.end_date.equals(selectedRange.end_date)) {
      intermittent_dates.push(
        {
          start_date: moment(selectedRange.end_date).add(1, 'days').toDate(),
          end_date: overlappedRange.end_date
        }
      )
    }
    this.setState({
      intermittent_dates: this.buildContinuousIntermittentDates(intermittent_dates)
    })
  }

  getDays () {
    if (this.props.employeeTheme) {
      return this.props.detail.benefit.days
    } else if (this.state.intermittent){
      var days = 0
      this.state.intermittent_dates.map(range => {
        const start_date = moment(range.start_date)
        const end_date = moment(range.end_date)
        days += end_date.add(1, 'days').diff(start_date, 'days')
      })
      return(this.getWeeksAndDays(days))
    } else {
      const start_date = moment(this.state.actual_leave_start_date)
      const end_date = moment(this.state.actual_leave_end_date)
      const days = end_date.add(1, 'days').diff(start_date, 'days')
      return(this.getWeeksAndDays(days))
    }
  }

  getWeeksAndDays (days) {
    let week_duration = ''
    let day_duration = ''
    const weeks = Math.floor(days / 7)
    let rem_days = days % 7
    if (weeks > 0) {
      week_duration = weeks + ' week'.pluralize(weeks, 'noun')
    }
    if (rem_days > 0) {
      day_duration = rem_days + ' day'.pluralize(rem_days, 'noun')
    }
    return([week_duration, day_duration].filter(duration => duration).join(' and '))
  }

  handleIntermittentDateChange (selectedRange) {
    const selected = this.isSelected(selectedRange)
    if (selected) {
      this.pushInIntermittent(selectedRange)
    } else {
      this.popFromIntermittentRange(selectedRange)
    }
  }

  extractSelectedDatesFor (calendar) {
    const calendarDate = this.defaultDateFor(calendar)
    const dates = this.state.intermittent_dates.map(range => {
      return this.enumerateDaysBetweenDates(range.start_date, range.end_date)
    }).flatten().filter(date => {
      return moment(date).year() === calendarDate.year() && moment(date).month() === calendarDate.month()
    })
    gon[`calendar_${calendar}_dates`] = dates
    return dates
  }

  enumerateDaysBetweenDates (startDate, endDate) {
    var currDate = moment(startDate);
    var dates = [currDate.format('YYYY-MM-DD')];
    var lastDate = moment(endDate);

    while(currDate.add(1, 'days').diff(lastDate) <= 0) {
        dates.push(currDate.clone().format('YYYY-MM-DD'));
    }

    return dates;
  }

  previousMonthShowable () {
    var {current_month} = this.state
    var minFirstMonth = moment(this.state.leave_start_milestone_date, 'MM/DD/YYYY').startOf('month').toDate()
    var currentFirstMonth = moment(current_month).startOf('month').toDate()
    return currentFirstMonth.greater_than(minFirstMonth)
  }

  showPreviousMonth () {
    var {current_month} = this.state
    if (this.previousMonthShowable()) {
      current_month = moment(current_month).add(-1, 'month').format('YYYY-MM-DD')
      this.setState({current_month})
    }
  }

  nextMonthShowable () {
    var {current_month} = this.state
    var maxLastMonth = moment(this.state.leave_end_milestone_date, 'MM/DD/YYYY').endOf('month').toDate()
    var currentLastMonth = moment(current_month).add(2, 'months').endOf('month').toDate()
    return currentLastMonth.less_than(maxLastMonth)
  }

  showNextMonth () {
    var {current_month} = this.state
    if (this.nextMonthShowable()) {
      current_month = moment(current_month).add(1, 'month').format('YYYY-MM-DD')
      this.setState({current_month})
    }
  }

  initializeBootstrapSwitchEligible () {
    $('.eligible-benefit-switch').bootstrapSwitch()
      .on('switchChange.bootstrapSwitch', (e) => {
        const eligible = this.state.eligible
        this.setState({eligible: !eligible})
      }).bind(this)
  }

  initializeBootstrapSwitchIntermittent() {
    $('.intermittent-switch').bootstrapSwitch('destroy')
    $('.intermittent-switch').bootstrapSwitch()
      .on('switchChange.bootstrapSwitch', (e) => {
        const intermittent = this.state.intermittent
        this.setState({intermittent: !intermittent})
      }).bind(this)
  }

  initializeBootstrapSwitchUsing() {
    $('.using-switch').bootstrapSwitch('destroy')
    $('.using-switch').bootstrapSwitch()
      .on('switchChange.bootstrapSwitch', (e) => {
        const using_benefit = this.state.using_benefit
        const intermittent = this.state.intermittent
        this.setState({using_benefit: !using_benefit})
      }).bind(this)
  }

  handleDateChange () {}
  handleSwitchChange () {}

  addClass (element, newClass) {
    element.className += ` ${newClass}`;
  }

  closePrompt () {
    const modalContainer = document.getElementsByClassName("react-modal");
    const modal = document.getElementsByClassName("react-modal-content modal-content");
    const backShadow = document.getElementsByClassName("back-shadow");
    this.addClass(modalContainer[0], "remove")
    this.addClass(modal[0], "remove slideOutPosition")
    this.addClass(backShadow[0], "remove")
    setTimeout ( (() => {
      this.setState ({
        show: false
      })
      this.props.cancel()
    }).bind(this), 500 )
  }

  renderMaxEligibleHours () {
    return (
      <div className='form-group'>
        <label className='label-control'> Max. Eligible Hours: </label>
        <input
          type='number'
          className='form-control'
          value={this.props.detail.benefit.max_leave_hours === '0.0' ? '0.0' : this.state.eligible_leave_hours}
          step='0.01'
          min='0.0'
          onChange={(e) => this.handleTextChange('eligible_leave_hours', e.target.value)}
        />
      </div>
    )
  }

  renderEligibleValues () {
    if (!this.props.employeeTheme) return null;

    return (
      <div className="eligible-hours">
        {(this.state.eligible && this.renderMaxEligibleHours())}
      </div>
    )
  }

  renderLeaveDates () {
    if (this.props.employeeTheme) return null;

    return this.state.intermittent_access && this.state.intermittent ?
      this.renderIntermittentDiv() :
      null
  }

  renderUsageDates () {
    return !this.props.employeeTheme && this.state.using_benefit && !this.state.intermittent ? this.renderEligibleUsageCalendarWithConstraint() : null
  }

  renderCalendarValues () {
    return this.state.eligible && this.props.detail.benefit.calculate ?
      (
        <div>
          {this.renderEligibleValues()}
          {this.renderIntermittentEligibleRange()}
          {this.renderIntermittendEligilibilityRangeList()}
          {this.state.using_benefit && this.renderLeaveDates()}
          {this.renderUsageDates()}
        </div>
      ) : null
  }

  renderEligibleUsageCalendarWithConstraint () {
    return (
      <div className='eligible-usage-start-end'>
        <div className='form-group'>
          <label className='label-control'>
            Using continuously from:
          </label>
          {this.renderDatePicker('actual_leave_start_date', 'actual-start-datepicker')}
        </div>
        <div className='form-group'>
          <label className='label-control end-date-label'>
            to
          </label>
            {this.renderDatePicker('actual_leave_end_date', 'actual-end-datepicker')}
        </div>
      </div>
    )
  }

  addEligibleIntermittentRange () {
    let ranges = this.state.eligible_intermittent_dates
    ranges.push({start_date: '', end_date: ''})
    this.setState({eligible_intermittent_dates: ranges})
  }

  renderIntermittentEligibleRange () {
    if (!this.props.employeeTheme) return null;
    return (
      <div className='eligible-usage-start-end'>
        <div className='form-group'>
          <label className='label-control'>
            Allow Benefit Eligible Range:
          </label>
        </div>
        <div className='form-group'>
          <label onClick={this.addEligibleIntermittentRange.bind(this)}>
            Add Range
          </label>
        </div>
      </div>
    )
  }
  
  eligibleRemoveIntermittentRange (index) {
    const ranges = this.state.eligible_intermittent_dates.filter((range, ind) => !(index==ind))
    this.setState({eligible_intermittent_dates: ranges})
  }

  renderIntermittentDatePicker(index, date, dataName, datepickerClass) {
    return (
      <div className='input-group'>
        <input
          type='text'
          className={`form-control datepicker intermittent`}
          data-name={`${dataName}-${index}`}
          value={date}
          required='required'
        />
        <span className='input-group-addon btn-darkgray' onClick={this.openDatePicker}>
          <span className='fa fa-calendar-o fa-lg'/>
        </span>
      </div>
    )
  }

  renderSingleIntermittent(index, range) {
    return (<div className='eligible-usage-start-end'>
        <div className='form-group'>
          <label className='label-control'>
          </label>
        </div>
        <div className='form-group'>
          {this.renderIntermittentDatePicker(index, range['start_date'], 'start_date', 'actual-start-datepicker')}
        </div>
        <div className='form-group'>
          <label className='label-control end-date-label'>
            to
          </label>
            {this.renderIntermittentDatePicker(index, range['end_date'], 'end_date', 'actual-end-datepicker')}
        </div>
        <div className='form-group'>
          <label className='label-control end-date-label' onClick={() => this.eligibleRemoveIntermittentRange(index)}>
            Remove
          </label>
        </div>
      </div>)
  }

  renderIntermittendEligilibilityRangeList () {
    if (!this.props.employeeTheme) return null;
    return (this.state.eligible_intermittent_dates.map((range, index) => this.renderSingleIntermittent(index, range)))
  }

  renderCheckBox (state, switchname ) {
    return (
      <input
        type='checkbox'
        className={switchname}
        checked={state}
        value='1'
        onChange={this.handleSwitchChange}
      />
    )
  }

  renderIntermittentSwitch () {
    return (
      <div>
        <div className='form-group'>
          <label className='label-control'> Intermittent? </label>
          {this.renderCheckBox(this.state.intermittent, 'intermittent-switch')}
        </div>
      </div>
    )
  }

  renderUsingSwitch() {
    return (
      <div>
        <div className='form-group'>
          <label className='label-control'> Using? </label>
          {this.renderCheckBox(this.state.using_benefit, 'using-switch')}
        </div>
      </div>
    )
  }

  renderHealthPlanWarning () {
    return this.state.eligible ?
      null :
      <div className='association-warning'>
        Any Tasks, Benefits, or Planning Guides associated to this Benefit will also be changed to Ineligible
      </div>
  }

  renderPreviousMonthNavigator () {
    return this.previousMonthShowable() ?
      (
          <span onClick={this.showPreviousMonth.bind(this)}> &lt;&lt;Prev </span>
      ) : null
  }

  renderNextMonthNavigator () {
    return this.nextMonthShowable() ?
      (
        <div className='col-xs-6'>
          <span onClick={this.showNextMonth.bind(this)}> Next&gt;&gt; </span>
        </div>
      ) : null
  }

  renderIntermittentDiv () {
    return (
      <div>
        <div className='intermittent-navigators'>
          <div className='show-previous-month'>
            {this.renderPreviousMonthNavigator()}
          </div>
          <div className='show-next-month'>
            {this.renderNextMonthNavigator()}
          </div>
        </div>

        <div className='intermittent-calendar-row'>
          {this.renderIntermittentCalendars()}
        </div>
      </div>
    )
    $('.datepicker-switch').removeClass('datepicker-switch')
  }

  renderIntermittentCalendars () {
    var calendars = []
    for (var calendar = 0; calendar <= 2; calendar++) {
      calendars.push(this.renderIntermittentCalendar(calendar))
    }
    return calendars
  }

  renderIntermittentCalendar (calendar) {
    return (
      <div>
        <div className={`intermittent-calendar-${calendar}`} key={`calendar-${calendar}`}/>
      </div>
    )
  }

  renderDatePicker (dataName, datepickerClass) {
    return (
      <div className='input-group'>
        <input
          type='text'
          className={`form-control datepicker ${datepickerClass}`}
          data-name={dataName}
          value={this.state[dataName]}
          required='required'
          onChange={this.handleDateChange}
        />
        <span className='input-group-addon btn-darkgray' onClick={this.openDatePicker}>
          <span className='fa fa-calendar-o fa-lg'/>
        </span>
      </div>
    )
  }

  renderNoOfDays () {
    return (
      <div>
        <div className='form-group'>
          <label className='label-control'> No. of Days </label>
          <label> {this.getDays()} </label>
        </div>
      </div>
    )
  }

  handleTextChange (key, value) {
    let temp = {}
    temp[key] = value
    this.setState(temp)
  }

  openDatePicker (e) {
    let datepicker = $(e.target).closest('.input-group').find('.datepicker')
    if(!datepicker.is(':disabled')) {
      datepicker.datepicker('show')
    }
  }

  itemImage () {
    return {
      backgroundImage: 'url('+ this.props.detail.benefit.image_url + ')'}
  }

  submitForm (e) {
    e.preventDefault()
    if (this.invalidIntermittentDates()) {
      toastr.error("Intermittent dates can't be empty")
    } else {
      this.props.approve(this.state)
      this.closePrompt()
    }
  }

  invalidIntermittentDates() {
    const {
      using_benefit,
      pending,
      eligible,
      intermittent,
      intermittent_dates
    } = this.state
    return using_benefit && (eligible || pending) && intermittent && intermittent_dates.length === 0
  }

  validLeaveEndDate (currentEndDate, maxEndDate) {
    if (currentEndDate) {
      if (moment(currentEndDate).isBetween(this.state.actual_leave_start_date, maxEndDate, 'MM/DD/YYYY')) {
        return currentEndDate
      } else {
        return maxEndDate
      }
    } else {
      return currentEndDate
    }
  }

  calculateLeaveEndDate (start_date, eligible_hours) {
    $.displaySpinner('span.spinner-place')
    const input_data = {
      actual_leave_start_date: start_date,
      eligible_leave_hours: eligible_hours
    }
    $.getJSON(`/leave_plan_benefits/${this.state.id}/calculate_overridden_end_date`, input_data, (response) => {
      $.removeSpinner()
      if(response.success) {
        let maxEndDate = moment(response.max_end_date).format('MM/DD/YYYY')
        let actualEndDate = this.validLeaveEndDate(this.state.actual_leave_end_date, maxEndDate)
        this.setState({max_end_date: maxEndDate, actual_leave_end_date: actualEndDate})
      } else {
        toastr.error(response.error_message)
      }
    })
  }

  eligibilityCheckHandler (eligibilityValue) {
    let eligibilityMapper = {
      eligible: {
        eligible: true, pending: false
      },
      pending:  {
        pending: true, eligible: true
      },
      ineligible: {
        eligible: false, pending: false
      }
    }

    this.setState(eligibilityMapper[eligibilityValue])
  }

  renderHelperText () {
    return (
      <span className='tooltip-helper eligible-tooltip'>
        <div className='helper-text'>
          <div className={`helper-tooltip hidden`}>
            <div className='helper-tooltip-text'>
            </div>
            <div className='helper-tooltip-pointer'></div>
          </div>
        </div>
      </span>
    )
  }

  render () {
    return this.state.show ? (
      <div className="react-modal">
        <div className="back-shadow" onClick={() => this.closePrompt()}>
        </div>
        <div className="modal-content react-modal-content">
          <div className="modal-header">
            <div className='item-header-container'>
              <div className='item-header'>
                <div className='name'>
                  {this.props.detail.benefit.name}
                </div>
              </div>
              <div className='image-div' style={this.itemImage()}/>
            </div>
          </div>
          <div className="modal-body leave-plan-benefit-modal">
            <form className='leave-plan-benefit-override-form' action='#' onSubmit={this.submitForm.bind(this)}>
              <div className='form-group'>
                <label className='label-control'> Eligible? </label>
                <MultiStateToggle
                  labelClass='toggle-btn'
                  wrapperClass='eligible-pending-wrapper'
                  labels={this.toggleLabels()}
                  handleClick={(value) => this.eligibilityCheckHandler(value)}
                />
              </div>

              {this.renderHealthPlanWarning()}
              {this.state.eligible && this.props.detail.benefit.calculate ? this.renderUsingSwitch() : null}
              {this.state.eligible && this.props.detail.benefit.calculate && this.state.using_benefit ? this.renderNoOfDays() : null}
              {!this.props.employeeTheme && this.state.eligible && this.props.detail.benefit.calculate && this.state.intermittent_access && this.state.using_benefit ? this.renderIntermittentSwitch() : null}
              {this.state.eligible ? this.renderCalendarValues() : null}
              <div className='form-group'>
                <label className='label-control'> Reason: </label>
                <textarea
                  type='text'
                  className='form-control'
                  required='required'
                  value={this.state.reason}
                  onChange={(e) => this.handleTextChange('reason', e.target.value)}
                />
              </div>
              <div className="buttons">
                <button className="cancel btn btn-danger" type='reset' onClick={this.closePrompt.bind(this)}>
                  Cancel
                </button>
                <button className="submit btn btn-primary" type='submit'>
                  Override
                </button>
              </div>
            </form>
          </div>
          {this.renderHelperText()}
        </div>
      </div>
    ) : null
  }
}

export default BenefitOverrideModal; 